import React, { Component } from 'react';
import BusinessWizardForm from './BusinessWizardForm';

class BusinessWizardModal extends Component {
  render() {
    const { isOpen, onClose, mode, businessItem, owner, onSaved } = this.props;

    if (!isOpen) {
      return null;
    }

    return (
      <div className="wizard-modal-overlay">
        <div className="wizard-modal-card">
          <div className="wizard-modal-header">
            <h3>{mode === 'edit' ? 'עריכת עסק' : 'הוספת עסק חדש'}</h3>

            <button type="button" className="wizard-close-btn" onClick={onClose}>
              ✕
            </button>
          </div>

          <div className="wizard-modal-body">
            <BusinessWizardForm
              mode={mode}
              businessItem={businessItem}
              owner={owner}
              onClose={onClose}
              onSaved={onSaved}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default BusinessWizardModal;